export const environment = {
  production: false,
  baseUrl: "https://dev-cms.mudico.be",
  apiBaseUrl: "https://dev-cms.mudico.be/api",
  apiBearerToken: "8646945880d263984a3e716a160f30a47bf3e5d740520228a98a38e9810fc419a5989bfa939fb9d58163cdff80da7f8a6d829c7814258b090cfb98d5b36b04fcde3a83b31c3ba639c6bec9f351ddcfcdfede0ba56ccab13ae14c4583834f5b7ccdd487ba57ac9d5ac7b510860644de17706dac794c7d1f829d192d32420e607c",
  cookieUrl: "mudico.be"
};
